import { MouseEvent, useState } from 'react';
import { EyeIcon, EyeSlashIcon } from '@phosphor-icons/react';
import TextField from '../TextField/TextField';
import { theme } from '../../../Style/theme';

interface PasswordFieldProps {
    register: any;
    label: string;
    fieldName: string;
    error: string | undefined;
}

export const PasswordField = ({ register, label, fieldName, error }: PasswordFieldProps) => {
    const [togglePassword, setTogglePassword] = useState(false);

    const handleTogglePassword = (e: MouseEvent) => {
        e.preventDefault();
        setTogglePassword((prev) => !prev);
    };

    return (
        <TextField
            required
            label={label}
            type={togglePassword ? 'text' : 'password'}
            rightIcon={
                <button onClick={handleTogglePassword} type="button">
                    {togglePassword ? (
                        <EyeSlashIcon size={24} fill={theme['secondary-dark-grey']} />
                    ) : (
                        <EyeIcon size={24} fill={theme['secondary-dark-grey']} />
                    )}
                </button>
            }
            {...register(fieldName)}
            error={error}
        />
    );
};
